<template>
	<div class="app-card-page-top">
		<slot />
	</div>
</template>

<style lang="scss">
.app-card-page-top {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;

	&.right {
		flex-direction: row-reverse;
	}

	.left {
		display: flex;
		align-items: center;
		gap: 1rem;
	}
}
</style>
